<template>
  <el-container class="app-main">
    <app-sidebar></app-sidebar>
    <el-container direction="vertical" class="app-content">
      <app-header></app-header>
      <el-main class="app-center">
        <breadcrumb></breadcrumb>
        <keep-alive :include="includes">
          <router-view :to="$route.path"></router-view>
        </keep-alive>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AppSidebar from '@/views/Layout/AppSidebar'
import AppHeader from '@/views/Layout/AppHeader'
import breadcrumb from '@/components/Common/breadcrumb'
import { mapState } from 'vuex'
export default {
  name: 'layout',
  components: {
    AppSidebar,
    AppHeader,
    breadcrumb
  },
  data () {
    return {
      contentStyle: ''
    }
  },
  computed: mapState({
    includes: 'includes'
  })
}
</script>

<style scoped>
  .app-content {
    padding: 0;
  }
  .app-center {
    padding: 0;
    background-color: #F7F8FA;
    /*background-color: #FFF;*/
  }
</style>
